import Markdown from "markdown-to-jsx";
import CitationList from "./CitationList";

const ROLE_PREFIX = {
  user: "User:",
  assistant: "Myracle Bot:",
};

// Renders one turn. Per the formatting requirement, both roles share the
// same left-column indentation - they're differentiated by color/prefix
// only, not by a left/right alignment flip.
const MessageBubble = ({ message, children }) => {
  const prefix = ROLE_PREFIX[message.role] || "";

  return (
    <div className={`chat-message ${message.role}`}>
      <div className="chat-bubble-group">
        <div className="chat-bubble">
          <span className="chat-bubble-prefix">{prefix}</span>
          {message.role === "assistant" ? (
            <Markdown
              className="chat-bubble-text"
              options={{
                forceBlock: true,
                // Security fix: message.answer is backend/LLM-sourced and
                // untrusted. By default markdown-to-jsx parses raw HTML
                // tags embedded in the markdown source into real DOM
                // elements/attributes (unlike CitationList's summary_html,
                // this content never goes through utils/sanitizeHtml).
                // disableParsingRawHTML makes any embedded raw HTML render
                // as literal, escaped text instead - markdown formatting
                // (bold, lists, links) is unaffected.
                disableParsingRawHTML: true,
                overrides: {
                  a: {
                    props: { target: "_blank", rel: "noopener noreferrer" },
                  },
                },
              }}>
              {message.answer || ""}
            </Markdown>
          ) : (
            <span className="chat-bubble-text">{message.text}</span>
          )}
        </div>
        {message.role === "assistant" && (
          <CitationList documents={message.documents} />
        )}
        {children}
      </div>
    </div>
  );
};

export default MessageBubble;
